module.exports = __webpack_public_path__ + "img/user.ba87325d.svg";